import resourceAPI from '../api/modules/resource.api.js';

export default class Resource {
  id=undefined;
  name=undefined;
  display_name=undefined;
  description=undefined;
  type=undefined;
  kind=undefined;
  url=undefined;
  column_x=undefined;
  column_y=undefined;
  crs=undefined;
  source_layer=undefined;
  source_layer_list=[];
  fileupload=undefined;
  filedownload=undefined;
  geoserver=undefined;
  published=true;
  postgres=undefined;
  postgis=undefined;
  href=undefined;
  ftp=undefined;
  lastUpdateDate=undefined;
  geographicLayer=undefined;
  extras=[];  
  schemaIdentifier='';
  schemaVersion='';
  schemaFormat='';
  dirty=false;
  file=undefined;
  _processing=[];
  constructor(input) { 
    if(input) { 
      Object.assign(this, input);
      this.display_name = input.name;
      this.lastUpdateDate = input.last_update_date;
      if(input.extras && input.extras.find(extra => extra.key === 'schema_version')){
        this.schemaVersion = input.extras.find(extra => extra.key === 'schema_version').value;
      }
      if(input.extras && input.extras.find(extra => extra.key === 'schema_identifier')){
        this.schemaIdentifier = input.extras.find(extra => extra.key === 'schema_identifier').value;
      }
      if(input.extras && input.extras.find(extra => extra.key === 'schema_format')){
        this.schemaFormat = input.extras.find(extra => extra.key === 'schema_format').value;
      }
      if(input.kind){
        resourceAPI.getResourceKinds().then((kinds)=>{
          this.kind = kinds ? kinds.find(kind => kind.codename === input.kind) : null;
        });
        
      }
    }   
  }
  isSchemaDataChanged() {
    if (
      this.extras &&
      this.extras.length > 0 &&
      this.extras.find(el => el.key === 'schema_identifier')
    ) {
      return this.schemaIdentifier !== this.extras.find(el => el.key === 'schema_identifier').value ||
        this.schemaVersion !== this.extras.find(el => el.key === 'schema_version').value ||
        this.schemaFormat !== this.extras.find(el => el.key === 'schema_format').value;
    } else {
      return false;
    }
  }
  isProcessingPending(){
    return this._processing.find((e)=>e.state=='PENDING')!=undefined;
  }
  isProcessingFailed(){
    return this._processing.find((e)=>e.state=='FAILURE')!=undefined;
  }
  isNotEmpty(){
    return (this.name!=undefined && this.name.length>0)
    ||(this.lastUpdateDate!=undefined && this.lastUpdateDate.length>0)
    ||(this.description!=undefined && this.description.length>0)
    ||(this.kind!=undefined && this.kind.codename!=undefined && this.kind.codename.length>0)
    ||this.getDataFormatCode()!=undefined && this.getDataFormatCode().length>0
;
  }
  toJSON() {
    if(this.schemaVersion!=undefined){
      let schemaVersion=this.extras.find(extra => extra.key === 'schema_version');
      if(schemaVersion!=undefined){
        schemaVersion.value=this.schemaVersion;
      }
      else{
        this.extras.push({ key:'schema_version',value:this.schemaVersion });
      }
    }
    if(this.schemaIdentifier!=undefined){
      let schemaIdentifier=this.extras.find(extra => extra.key === 'schema_identifier');
      if(schemaIdentifier){
        schemaIdentifier.value=this.schemaIdentifier;
      }
      else{
        this.extras.push({ key:'schema_identifier',value:this.schemaIdentifier });
      }
    }
    if(this.schemaFormat!=undefined){
      let schemaFormat=this.extras.find(extra => extra.key === 'schema_format');
      if(schemaFormat){
        schemaFormat.value=this.schemaFormat;
      }
      else{
        this.extras.push({ key:'schema_format',value:this.schemaFormat });
      }
    }
    let json = {
      id: this.id,
      name: this.name,
      description: this.description,
      column_x:this.column_x,
      column_y:this.column_y,
      crs:this.crs,
      published:this.published,
      source_layer:this.source_layer,
      type: this.type,
      kind: this.kind ? this.kind.codename:null,
      extras:this.extras,
      last_update_date:this.lastUpdateDate,
      geographicLayer:this.geographicLayer,
    };
    if(this.type=='geoserver'){
      json.geoserver=this.geoserver;
    }
    if(this.type=='file-upload'){
      json.fileupload=this.fileupload;
    }
    if(this.type=='file-download'){
      json.filedownload=this.filedownload;
    }
    if(this.type=='postgres'){
      json.postgres=this.postgres;
    }
    if(this.type=='postgis'){
      json.postgis=this.postgis;
    }
    if(this.type=='href'){
      json.href=this.href;
    }
    if(this.type=='ftp'){
      json.ftp=this.ftp;
    }
    return json;
  }
  hasGeographicLayer() {
    return this.geographicLayer ? true : false;
  }
  isGeoserver() {
    return this.type === 'geoserver' ? true : false;
  }
  getDataFormatCode(){
    if(this.getDataSource()){
      return this.getDataSource().dataformat;
    }
    return '';
    
  }
  getDataSource(){
    if(this.fileupload){
      return this.fileupload;
    }
    if(this.filedownload){
      return this.filedownload;
    }
    if(this.ftp){
      return this.ftp;
    }
    return null;
  }
  getDataFormat() {
    let formats=resourceAPI.resourceDataFormats;
    return formats ? formats.find(format => format.codename === this.getDataFormatCode()) : null;
  }
  
  isGeospatial() {
    return this.isXY()||(this.getDataFormat() && this.getDataFormat().type.value === 'geospatial');
  }
  isXY() {
    return this.getDataFormat() && this.getDataFormat().type.value === 'tabular-xy';
  }


}